import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63cc3122"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Component Type")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Predefined names for system popups")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Component name")
], -1))
const _hoisted_4 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.customComponentRef,
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      (_ctx.method != 'Duplicate')
        ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            ref: "type",
            name: "type"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_a_select, {
                defaultValue: "popup",
                value: _ctx.customComponentRef.type,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customComponentRef.type) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTemplate()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Choose type")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "popup" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Popup")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form_item, {
        ref: "isSystem",
        name: "isSystem"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_checkbox, {
            checked: _ctx.customComponentRef.isSystem,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customComponentRef.isSystem) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Is system component ")
            ]),
            _: 1
          }, 8, ["checked"])
        ]),
        _: 1
      }, 512),
      (_ctx.customComponentRef.isSystem)
        ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            ref: "name",
            name: "name"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_a_select, {
                defaultValue: "Choose if system popup",
                value: _ctx.customComponentRef.name,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customComponentRef.name) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTemplate()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 'Popup base template' || '' }, {
                    default: _withCtx(() => [
                      _createTextVNode("Choose")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "claim-item" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Claim item")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "redeem-qr-success" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Redeem QR code success")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "incorrect-qr-code" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Incorrect QR code")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "already-redeemed-qr" }, {
                    default: _withCtx(() => [
                      _createTextVNode("QR code already redeemed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "redeem-momint-nft-success" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Redeem Momint NFT success")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "already-redeemed-momint-nft" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Momint NFT already redeemed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "tap-to-redeem-prompt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tap to redeem prompt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "tap-to-redeem-success" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tap to redeem success")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "already-redeemed-tap-to-redeem" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Already redeemed tap to redeem")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "redeem-voucher-prompt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Redeem voucher prompt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "redeem-voucher-success" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Redeem voucher success")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "already-redeemed-voucher" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Voucher code already redeemed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "redeem-url-voucher-prompt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Redeem URL voucher prompt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "already-redeemed-url-voucher" }, {
                    default: _withCtx(() => [
                      _createTextVNode("URL Voucher code already redeemed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "out-of-drop-zone" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Out of drop zone")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "max-items-claimed" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Max Items claimed")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "out-of-items" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Out of items")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      (!_ctx.customComponentRef.isSystem)
        ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 2,
            ref: "name",
            name: "name"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_a_input, {
                type: "text",
                value: _ctx.customComponentRef.name,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customComponentRef.name) = $event)),
                placeholder: "CustomComponent name",
                class: "ant-input"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              style: {"margin-right":"10px"},
              type: "default",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}